export const FETCHING_RAFFLE = '@app/raffleDetail/fetchingRaffle';
export const FETCHED_RAFFLE = '@app/raffleDetail/fetchedRaffle';
export const CLEAR_FETCHED_RAFFLE = '@app/raffleDetail/clearFetchedRaffle';

export const fetchingRaffleAction = () => ({
	type: FETCHING_RAFFLE
});

export const fetchedRaffleAction = (raffle) => ({
	type: FETCHED_RAFFLE,
	raffle
});

export const clearFetchedRaffleAction = () => ({
	type: CLEAR_FETCHED_RAFFLE
});



// WEBPACK FOOTER //
// ./actions/RaffleDetailActions.js